import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import BasicInputsStep from './BasicInputsStep';
import IncomeSourcesStep from './IncomeSourcesStep';
import StrategyStep from './StrategyStep';
import AdvancedSettingsStep from './AdvancedSettingsStep';

/**
 * Retirement Input Tabs - Organizes all input sections into logical tabs
 */
export default function RetirementInputTabs({
  inputs,
  updateInput,
  updateSpendingSplit,
  setInputs,
  country,
  currencySymbol,
  statePensionEstimate,
  accounts,
  investments,
  monteCarloScenarios,
  setMonteCarloScenarios,
  activeInputTab,
  setActiveInputTab
}) {
  return (
    <Tabs value={activeInputTab} onValueChange={setActiveInputTab} className="w-full">
      <div className="overflow-x-auto -mx-3 sm:mx-0 mb-4">
        <TabsList className="inline-flex w-full min-w-max sm:grid sm:grid-cols-4 sm:min-w-0">
          <TabsTrigger value="basics" className="text-xs sm:text-sm whitespace-nowrap">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-bold text-sm mr-2">1</span>
            Basics
          </TabsTrigger>
          <TabsTrigger value="income" className="text-xs sm:text-sm whitespace-nowrap">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 font-bold text-sm mr-2">2</span>
            Income Sources
          </TabsTrigger>
          <TabsTrigger value="strategy" className="text-xs sm:text-sm whitespace-nowrap">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300 font-bold text-sm mr-2">3</span>
            Strategy
          </TabsTrigger>
          <TabsTrigger value="advanced" className="text-xs sm:text-sm whitespace-nowrap">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-900 text-orange-700 dark:text-orange-300 font-bold text-sm mr-2">4</span>
            Advanced
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="basics" className="mt-0">
        <BasicInputsStep
          inputs={inputs}
          updateInput={updateInput}
          updateSpendingSplit={updateSpendingSplit}
          country={country}
          currencySymbol={currencySymbol}
        />
      </TabsContent>

      <TabsContent value="income" className="mt-0">
        <IncomeSourcesStep
          inputs={inputs}
          updateInput={updateInput}
          setInputs={setInputs}
          country={country}
          currencySymbol={currencySymbol}
          statePensionEstimate={statePensionEstimate}
        />
      </TabsContent>

      <TabsContent value="strategy" className="mt-0">
        <StrategyStep
          inputs={inputs}
          setInputs={setInputs}
          country={country}
          currencySymbol={currencySymbol}
          accounts={accounts}
          investments={investments}
        />
      </TabsContent>

      <TabsContent value="advanced" className="mt-0">
        <AdvancedSettingsStep
          inputs={inputs}
          updateInput={updateInput}
          monteCarloScenarios={monteCarloScenarios}
          setMonteCarloScenarios={setMonteCarloScenarios}
        />
      </TabsContent>
    </Tabs>
  );
}
